import { render, staticRenderFns } from "./editCompetency.vue?vue&type=template&id=41ccd9c6&"
import script from "./editCompetency.vue?vue&type=script&lang=js&"
export * from "./editCompetency.vue?vue&type=script&lang=js&"
import style0 from "./editCompetency.vue?vue&type=style&index=0&id=41ccd9c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports